import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { buttonStyles } from '../../../Components/docsAdministrative/JsObjectStyles';

function CreateAOButtonsHeader({ aoId, intitulePoste, role }) {

    CreateAOButtonsHeader.propTypes = {
        aoId: PropTypes.any,
        intitulePoste: PropTypes.any,
        role: PropTypes.any,
    };
    let navigate = useNavigate();
    const {pathname} = useLocation();
    const { i18n } = useTranslation();

    const pathRedirection = (current) => {
        if(pathname==current)
            navigate('.',{state:{ aoId}});
        else
            navigate(current,{state:{ aoId}});
    };

    const checkWeAreInCurrentPath = (current) => {
        if(pathname==current)
            return true;
        else
            return false;
    };

    return (
        <>
            {aoId ?
                <h4 className='titlesociete'>{i18n.t('Modifier l\'appel d\'offres')} : {intitulePoste}</h4>
                :
                <h4 className='titlesociete'>{i18n.t('Créer un appel d\'offres')}</h4>
            }
            <div className='Frame237501'>
                <div
                    className='kbismenustyle'
                    style={{ cursor: aoId === undefined ? 'default' : 'pointer' }}
                >
                    <Button
                        disabled={aoId ? false : true}
                        onClick={()=>pathRedirection(`/${role}/createAO`)}
                        style={
                            checkWeAreInCurrentPath(`/${role}/createAO`)  ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'40px',
                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'40px',
                                }}
                        }
                        //style={checkWeAreInCurrentPath('/client/createAO') ? selectedFrameCvTheque : notSelectedFrameCvTheque}
                    > {i18n.t('Données Entreprise')}</Button>
                </div>
                <div
                    className='kbismenustyle'
                    style={{ cursor: aoId === undefined ? 'default' : 'pointer' }}
                >
                    <Button
                        disabled={aoId ? false : true}
                        onClick={()=>pathRedirection(`/${role}/createAO/next`)}
                        style={
                            checkWeAreInCurrentPath(`/${role}/createAO/next`)   ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'40px',
                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'40px',
                                }}
                        }
                        //style={checkWeAreInCurrentPath(`/${role}/createAO/next`) ? selectedFrameCvTheque : notSelectedFrameCvTheque}
                    > {i18n.t('Données Projet')}</Button>
                </div>
                <div
                    className='kbismenustyle'
                    style={{ cursor: aoId === undefined ? 'default' : 'pointer' }}
                >
                    <Button
                        disabled={aoId ? false : true}
                        onClick={()=>pathRedirection(`/${role}/createAO/last`)}
                        style={
                            checkWeAreInCurrentPath(`/${role}/createAO/last`) ?
                                {...buttonStyles(),...{
                                    background: '#E7EAF9',
                                    color: '#214DCE',
                                    borderRadius:'40px',

                                }}:
                                {...buttonStyles(),...{
                                    color: '#475063',
                                    borderRadius:'40px',

                                }}
                        }
                        //style={checkWeAreInCurrentPath('/client/createAO/last') ? selectedFrameCvTheque : notSelectedFrameCvTheque}
                    > {i18n.t('Exigences Projet')}</Button>
                </div>
            </div>
        </>
    );
}
export default CreateAOButtonsHeader;